import React, { useContext, useState } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";

function TwoSteps() {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { themeStatus } = Constant();
  const [isChecked, setIsChecked] = useState(false);

  const toggleSwitch = () => {
    setIsChecked((prev) => !prev);
  };

  return (
    <div
      id="TwoSteps"
      className={`card ${themeStatus?.[selectedTheme]} cardSetting`}
    >
      <div className="card-header">
        <h4 className="card-title">{t("Two-step Verification")}</h4>
      </div>

      <div className="card-body">
        <label
          className="form-check-label responsive-text"
          style={{ color: "var(--text-email)" }}
        >
          {t(
            "Start by entering your password so that we know it’s you. Then we’ll walk you through two more simple steps."
          )}
        </label>

        <div className="d-flex w-100 justify-content-between align-items-center mt-3">
          <label
            className="form-label card-text"
            style={{ color: "var(--whiteToBlack)" }}
          >
            {t("Account Password")}
          </label>
          <div style={{ width: "65%" }}>
            <input
              type="text"
              className="form-control account-placeholder rounded-2 "
              placeholder={t("Enter current password")}
              name="nameOnCard"
            />
          </div>
        </div>
        <div
          className={`d-flex flex-column mb-2 mt-4 pb-3 px-3 pt-2 bg-soft-secondary rounded`}
        >
          <div className="d-flex justify-content-between align-items-center">
            <h5
              style={{
                paddingTop: "12px",
                paddingBottom: "3px",
                margin: "unset",
                fontSize: "18px",
                fontWeight: "600",
                color: "var(--whiteToBlack)",
              }}
            >
              {t("Two-step verification")}
            </h5>

            <label
              className="form-check form-switch pt-3 d-md-none d-block"
              htmlFor="accounrSettingsPreferencesSwitch1"
            >
              <span className="">
                <input
                  type="checkbox"
                  className="form-check-input me-0 "
                  style={{
                    width: "51px",
                    height: "25px",
                    backgroundColor: isChecked
                      ? "rgba(56, 124, 255, 1)"
                      : "var(--toggle-color)",
                  }}
                  id="accounrSettingsPreferencesSwitch1"
                  checked={isChecked}
                  onClick={toggleSwitch}
                />
              </span>
            </label>
          </div>

          <div className="d-flex gap-3">
            <p
              className="pt-2"
              style={{
                fontSize: "14px",
                fontWeight: "400",
                margin: "unset",
                color: "rgba(108, 116, 122, 1)",
              }}
            >
              {t(
                "Two-factor authentication is an enhanced security measure. Once enabled, you’ll be required to give two types of identification when you log into BacklinksFactory. Google Authenticator is supported."
              )}
            </p>
            <label
              className="form-check form-switch d-md-flex d-none"
              htmlFor="accounrSettingsPreferencesSwitch1"
            >
              <span className="">
                <input
                  type="checkbox"
                  className="form-check-input me-0"
                  style={{
                    width: "51px",
                    height: "25px",
                    backgroundColor: isChecked
                      ? "rgba(56, 124, 255, 1)"
                      : "var(--toggle-color)",
                  }}
                  id="accounrSettingsPreferencesSwitch1"
                  checked={isChecked}
                  onClick={toggleSwitch}
                />
              </span>
            </label>
          </div>
        </div>
      </div>
      <div className="card-header p-0"></div>
      <div className="d-flex justify-content-end card-body pt-3">
        <button className="btn btn-primary edit-profile-btn p-0">
          {t("Save Changes")}
        </button>
      </div>
    </div>
  );
}

export default TwoSteps;
